import { render, staticRenderFns } from "./historyRecommend.vue?vue&type=template&id=67aa622e&scoped=true&"
import script from "./historyRecommend.vue?vue&type=script&lang=js&"
export * from "./historyRecommend.vue?vue&type=script&lang=js&"
import style0 from "./historyRecommend.vue?vue&type=style&index=0&id=67aa622e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa622e",
  null
  
)

export default component.exports